<template>
  <span style="text-align:left">
    <template v-if="modo=='new'||modo=='edit'||modo=='flow'">
      <v-input
        :value="(value)"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <masked-input
          type="text"
          name="phone"
          class="mt-4"
          v-bind:value="preLoad(value)"
          v-on:input="(event)=>$emit('input', preUpdate(event))"
          :mask="['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
          :guide="false"
          placeholderChar="#"
        ></masked-input>
      </v-input>
    </template>

    <template v-if="modo=='list' || modo=='view' || modo=='viewmode'">
      <span :class="{'text-xs-center':span=='list'}">{{displayvalue}}</span>
    </template>

    <template v-if="modo=='filtro'">
      <v-text-field
        height="20"
        class="ma-0 pa-1"
        hide-details
        v-bind:value="preLoadFiltro(value)"
        v-on:input="(event)=>$emit('input', preUpdateFiltro(event))"
        :mask="getComponentParam('mask')"
        clearable
      ></v-text-field>
    </template>
  </span>
</template>
    

<script>
try{
  var _baseComponent = require("@/lib/componente/_base.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
import MaskedInput from "vue-text-mask";

export default {
  extends: _baseComponent,

  data() {
    return {};
  },
  methods: {},
  components: {
    MaskedInput,
  },
};
</script>

<style scoped>
</style>

    